module.exports = __webpack_public_path__ + "img/Viiata_lui_Bertoldo_Sibiu_1799_foaie_de_titlu.2a54388b.jpg";